import { render } from "./Screen8.vue?vue&type=template&id=06a65c3c&scoped=true"
import script from "./Screen8.vue?vue&type=script&lang=js"
export * from "./Screen8.vue?vue&type=script&lang=js"

import "./Screen8.vue?vue&type=style&index=0&id=06a65c3c&lang=css"
import "./Screen8.vue?vue&type=style&index=1&id=06a65c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a65c3c"]])

export default __exports__